<template>
    <div id="retailstore_c">
        <div style="height: 120px;border-bottom: 2px dashed #eee">
            <el-row>
                <el-col>
                    <span class="demonstration" style="border-radius: 5px;margin-right: 15px">时间范围</span>
                    <el-date-picker
                            @click.native="typeChange"
                            style="width: 160px;margin-right: 50px"
                            v-model="dateValue"
                            type="month"
                            placeholder="选择月">
                    </el-date-picker>
                    <span class="demonstration" style="margin-right: 15px">
                年份
            </span>
                    <el-select style="width: 160px" v-model="dateValue2"  placeholder="请选择" value="">
                        <el-option
                                v-for="item in options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>

                    <div style="float: right">
                        <span style="margin-right: 15px">人员</span>
                        <inputSelect :handleSelectInput="handleSelectInputClick"></inputSelect>
                    </div>
                </el-col>
                <el-col span="24" style="margin-top: 24px">
                    <el-button type="primary" size="small" @click="searchWeekList"
                               style="background: #4EC880;border: none">
                        查询
                    </el-button>
                    <el-button type="danger" size="small" @click="ResetClick"
                               style="background: #D0021B;border: none">
                        重置
                    </el-button>
                </el-col>
            </el-row>
        </div>
        <el-row style="margin-top: 20px">

            <el-col span="24"><span style="font-size: 18px;">
                 <span style="vertical-align:middle;font-size: 17px">
                    2019年9月
                </span>
                <span style="font-size: 12px;margin-left: 10px;color:#FF9901;vertical-align:middle">
                    门店总数 35家
                </span>
                <span style="font-size: 12px;margin-left: 10px;color: #4A90E2;vertical-align:middle">
                    A类12家|B类10家|C类6家|D类7家
                </span>
            </span>
            </el-col>
        </el-row>
        <el-row style="margin-top: 20px">
            <el-table
                    :data="tableData"
                    style="width: 100%">
                <el-table-column
                        prop="date"
                        label="门店名称"
                        sortable
                >
                </el-table-column>
                <el-table-column
                        prop="name"
                        label="涉及产品数"
                        sortable
                >
                </el-table-column>
                <el-table-column
                        prop="address"
                        label="类型"
                        sortable>
                </el-table-column>
                <el-table-column
                        prop="address"
                        sortable
                        label="级别">
                </el-table-column>
                <el-table-column
                        prop="address"
                        sortable
                        label="客户等级">
                </el-table-column>
                <el-table-column
                        prop="address"
                        sortable
                        label="店员人数">
                </el-table-column>
            </el-table>
        </el-row>
    </div>
</template>

<script>
    import inputSelect from '../../../../calendar/components/components/inputSelect'
    export default {
        name: "institution",
        data(){
            return {
                form:{},
                tableData: [{
                    date: '王晓云',
                    name: '4',
                    address: '-'
                }, {
                    date: '王晓云',
                    name: '3',
                    address: '-'
                }, {
                    date: '王晓云',
                    name: '2',
                    address: '-'
                }, {
                    date: '王晓云',
                    name: '2',
                    address: '-'
                }],
                onoff:false,
                roomChart:'',
                gradeChart:'',
                dateValue2:'',
                dateValue:'',
            }
        },
        components:{
            inputSelect
        },
        mounted(){
            this.init()

            window.onresize = () => {
                this.roomChart.resize()
                this.gradeChart.resize()
            }
        },
        methods:{
            init(){
            },
            handleSelectInputClick(){

            },
            typeChange(){
            }

        }
    }
</script>

<style scoped>
    #retailstore_c .custDiv_border:before{
        content:" ";
        height: 100px;
        border: 1px solid #9FA5AC;
        float: right;
        margin-top: 40px;
    }
    #retailstore_c >>> .el-progress-bar{
        padding-right: 60px;
    }
    #retailstore_c >>> .el-progress-bar__outer{
        border-radius: 2px;
    }
    #retailstore_c >>> .el-progress-bar__inner{
        border-radius: 2px;
    }
    #retailstore_c >>> .el-rate__icon{
        border-radius: 4px;
        overflow: hidden;
    }
    #retailstore_c >>> .el-rate__item{
        width: 18px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/dashboard/components/summarize/components/retailstore.vue